import type { QueryKey } from '@tanstack/query-core';
import type { QueryClient } from '@tanstack/react-query';

type DataUpdateFunction<TInput, TOutput> = (input: TInput) => TOutput;

/**
 * Custom implementation of setQueryData that sets cacheTime to infinity, which would
 * default to 5min otherwise.
 */
export function setQueryDataWithDefaults<TQueryFnData>(
    client: QueryClient,
    queryKey: QueryKey,
    updater: DataUpdateFunction<TQueryFnData | undefined, TQueryFnData | undefined>,
): void {
    client.setQueryDefaults(queryKey, {
        gcTime: Infinity,
    });
    client.setQueryData(queryKey, updater);
}
